export default {
    api: {
        url: process.env.REACT_APP_LOCAL_BASE_URL,
        mode: 'cors'
    },
}